import { createProfileSave } from './states';

export const services = {
  createProfileSave,
};
